module.exports = __webpack_public_path__ + "img/nori-danilo.70e75ba3.jpg";